// Should stay in sync with commentActionType.mjs

export const COMMENT_ACTION_TYPES = {
  CREATED: 1,
  EDITED: 2,
  DELETED: 3
};
